import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';
// import { createContactsData } from '../models/contacts-data.model';
// import { createContactDetails } from '../models/contact-details.model';

export const contactGroupMutations = {
  [types.ContactGroups.SET.ALL](state, payload) {
    state.contactGroups = payload;
  },
  [types.SelectedContactGroup.SET.SINGLE](state, payload) {
    state.selectedContactGroup = payload;
  },
  [types.GroupContactsData.SET.ALL](state, payload) {
    console.log('payload', payload)
    state.selectedContactGroup = {
      ...state.selectedContactGroup,
      contacts: payload
    };
  },
  [types.SelectedContactGroupLoading.SET.SINGLE](state, payload) {
    state.selectedContactGroupLoading = payload;
  },
  ...implementSetAllNavTabDetailsMutation(types.ContactGroupDetails, 'contactGroupDetails'),
  // [types.SelectedContact.SET.SINGLE] (state, payload) {
  //   state.selectedContact = createContactDetails(payload);
  // },
  // [types.SelectedContactLoading.SET.SINGLE] (state, payload) {
  //   state.selectedContactLoading = payload;
  // },
  // [types.SelectedContactGroups.DELETE.SINGLE] ({selectedContact = createContactDetails()}, payload) {
  //   selectedContact.related_groups = selectedContact.related_groups.filter(g => {
  //     if (g.group_id == payload.group_id) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   })
  // },
  // [types.SelectedContactGroups.SET.ALL] (state, payload) {
  //   state.selectedContact.related_groups = payload;
  // },
  // [types.SelectedContact.UPDATE.SINGLE] (state, payload) {
  //   const { name, value } = payload;
  //   state.selectedContact = createContactDetails({
  //     ...state.selectedContact,
  //     contact: {
  //       ...state.selectedContact.contact,
  //       [name]: value
  //     }
  //   });
  // },
  // [types.SelectedContactRelatedContacts.SET.ALL] (state, payload) {
  //   console.log(payload);
  //   state.selectedContact.contact_relations = payload;
  // },
  // [types.SelectedContactRelatedContacts.UPDATE.SINGLE](state, payload) {
  //   const { name, value, item } = payload;
  //   state.selectedContact.contact_relations = selectedContact.contact_relations.map(cr => {
  //     if (cr.contact_id == item.contact_id) {
  //       return {
  //         ...cr,
  //         [name]: value
  //       };
  //     } else {
  //       return cr;
  //     }
  //   });
  // },
  // [types.SelectedContactRelatedContacts.DELETE.SINGLE](state, payload) {
  //   state.selectedContact.contact_relations = selectedContact.contact_relations.filter(cr => {
  //     if (cr.contact_id == payload.contact_id) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   })
  // }
}